import { createRoot } from 'react-dom/client'
import '@chinese-fonts/zqfs/dist/ZhuqueFangsong-Regular/result.css'
import { App } from './App'
import './styles.css'

createRoot(document.getElementById('root')!).render(<App />)
